// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconWarning.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconWarning = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 12" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M6.90138 1.33537C6.50077 0.554879 5.49923 0.554878 5.09862 1.33537L0.140998 10.2439C-0.259618 11.0244 0.241151 12 1.04238 12H10.9576C11.7588 12 12.2596 11.0244 11.859 10.2439L6.90138 1.33537ZM5.42967 7.65H6.57033L6.75 3.75H5.25L5.42967 7.65ZM6 10.5C6.41421 10.5 6.75 10.1474 6.75 9.7125C6.75 9.27757 6.41421 8.925 6 8.925C5.58579 8.925 5.25 9.27757 5.25 9.7125C5.25 10.1474 5.58579 10.5 6 10.5Z" />
  </BaseIcon>
);

export default IconWarning;
